export enum ResultRequestRoutesEnum {
    Home = '/',
    NewResultRequest = '/new-result-request',
    ResultRequest = '/result-request',
}
